import { render } from "./ApprovalQueue.vue?vue&type=template&id=2942ecb0&scoped=true"
import script from "./ApprovalQueue.vue?vue&type=script&lang=js"
export * from "./ApprovalQueue.vue?vue&type=script&lang=js"

import "./ApprovalQueue.vue?vue&type=style&index=0&id=2942ecb0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2942ecb0"]])

export default __exports__